const ProductCardType = Object.freeze({
  BIKE: 'BIKE',
  AFTERMARKET: 'AFTERMARKET',
});
const BrandName = Object.freeze({
  TREK: 'trek-logo',
  ELECTRA: 'electra-logo',
  BONTRAGER: 'bontrager-logo',
  DIAMANT: 'diamant-logo',
  TREK_TRAVEL: 'trek-travel-logo',
});
export {ProductCardType, BrandName};
